import React, { useEffect } from 'react'
import './styles.scss'

function AppOrderRedirect() {
  useEffect(() => {
    window.location.href = 'pinka://order'
  }, [])

  return (
    <div className='app_order_redirect'>
      <h3>Redirecting...</h3>
    </div>
  )
}

export default AppOrderRedirect
